import React from 'react'

const Achievement = ({ icon, title }) => {
  return (
    <div className="flex gap-2 items-center juarify-center">
      <div className="flex items-center justify-center rounded-full bg-primary size-10">
        {icon}
      </div>
      <span className="text-sm font-bold">{title}</span>
    </div>
  )
}

export default Achievement
